exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root {\n\n  /*colors named by https://www.color-blindness.com/color-name-hue/*/\n\n  /*shadow*/\n\n  /*z-index*/\n\n  /*transition*/\n\n  /*radius*/\n\n  /*chat*/\n}\n\n._2OQZjPh {\n  position: relative;\n}\n\n.MWbHFt2 {\n    width: 160px;\n    margin: 0 auto 45px;\n  }\n\n.MWbHFt2 img {\n      max-width: 100%;\n      max-height: 100%;\n    }\n\n._3jZEPrN {\n    margin: 0 0 24px;\n  }\n\n.P-0Gmn_ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: 360px;\n    margin: 3px 0 0;\n    padding: 0 20px;\n  }\n\n._2Wm-iRN {\n    padding: 0 9px;\n  }\n\n._1uvcuQ3 {\n    width: 100%;\n    margin: 47px 0 0;\n  }\n", ""]);
// Exports
exports.locals = {
	"PhoneForm": "_2OQZjPh",
	"PhoneForm__logo": "MWbHFt2",
	"PhoneForm__field": "_3jZEPrN",
	"PhoneForm__checkbox": "P-0Gmn_",
	"PhoneForm__checkboxLabel": "_2Wm-iRN",
	"PhoneForm__submit": "_1uvcuQ3"
};